import type { CalendarNavigationState } from "./use-calendar-navigation";

export function useDisplayDays(nav: CalendarNavigationState) {
  return nav.calendarMode === "month"
    ? nav.monthDays
    : nav.calendarMode === "day"
      ? nav.dayDays
      : nav.weekDays;
}
